import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SignupPage = lazy(() => import('../pages/signup/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const DemoPage = lazy(() => import('../pages/demo/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog-article/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AgentDetailPage = lazy(() => import('../pages/agent-detail/page'));
const ABTestingPage = lazy(() => import('../pages/ab-testing/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const LegalNoticePage = lazy(() => import('../pages/legal-notice/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const InvoiceDetailPage = lazy(() => import('../pages/invoice-detail/page'));
const MarketplacePage = lazy(() => import('../pages/marketplace/page'));
const DeploymentPage = lazy(() => import('../pages/deployment/page'));
const IntegrationsPage = lazy(() => import('../pages/integrations/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const KnowledgeBasePage = lazy(() => import('../pages/knowledge-base/page'));
const AutomationPage = lazy(() => import('../pages/automation/page'));
const SystemHealthPage = lazy(() => import('../pages/system-health/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute>
        <OnboardingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard/invoice/:invoiceId',
    element: (
      <ProtectedRoute>
        <InvoiceDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/marketplace',
    element: <MarketplacePage />,
  },
  {
    path: '/deployment',
    element: (
      <ProtectedRoute>
        <DeploymentPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/demo',
    element: <DemoPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/agents/:agentType',
    element: <AgentDetailPage />,
  },
  {
    path: '/ab-testing',
    element: <ABTestingPage />,
  },
  {
    path: '/integrations',
    element: (
      <ProtectedRoute>
        <IntegrationsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/knowledge-base',
    element: (
      <ProtectedRoute>
        <KnowledgeBasePage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/automation',
    element: (
      <ProtectedRoute>
        <AutomationPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/legal-notice',
    element: <LegalNoticePage />,
  },
  {
    path: '/system-health',
    element: (
      <ProtectedRoute>
        <SystemHealthPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/404',
    element: <NotFoundPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
];

export default routes;